import React from 'react';
import { APPLE_TAGS } from '../constants';

const renderAppleTags = () =>
  APPLE_TAGS.map(({ href, rel, sizes }) => <link href={href} rel={rel} sizes={sizes} />);

export default renderAppleTags;
